import React from 'react';

import { LoadingButton } from '@mui/lab';
import { Typography } from '@mui/material';

type Props = {
  isDisabled: boolean;
  isLoading: boolean;
  onClick: () => void;
};

const CheckCodesButton: React.FC<Props> = ({
  isDisabled,
  isLoading,
  onClick,
}) => {
  return (
    <LoadingButton
      loading={isLoading}
      disabled={isDisabled}
      onClick={onClick}
      variant='contained'
      color='primary'
      sx={{
        borderRadius: '40px',
        height: '40px',
        padding: '0 20px',
      }}
      disableElevation
    >
      <Typography color='#ffffff'>Check Codes</Typography>
    </LoadingButton>
  );
};

export default CheckCodesButton;
